module.exports = __webpack_public_path__ + "assets/img/二级页面标题@2x (6).500d1a11.png";